module.exports = __webpack_public_path__ + "open-sans-v17-latin-300.woff2?24f7b0944e9e03a905f9d7701573b2cd";